module.exports = __webpack_public_path__ + "static/media/menuAddressBook.1dfd894f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/menuAddressBook.svg
// module id = 462
// module chunks = 0